import * as React from "react";
import "../../../../../utils/number_extensions"
import { IBudgetDetails } from "../../../../../config/budget";
import { fillMonths } from "../../../../../helpers/budget_helpers";
import { useGlobalStores } from "../../../../../hooks/use_global_stores";
import moment from "moment";
import { BarPlot, ChartContainer, ChartsAxisHighlight, ChartsTooltip, ChartsXAxis, ChartsYAxis, LinePlot } from "@mui/x-charts";
import { Box, useTheme } from "@mui/material";

interface IBudgetDetailsUsagesProps {
    budget: IBudgetDetails;
    year: number;
}

export const BudgetDetailsUsages = ({budget, year}: IBudgetDetailsUsagesProps) => {
    const theme = useTheme();
    const { currencyStore } = useGlobalStores();

    const dataset = fillMonths(budget, year).map((item: any) => {
        const [date, amountUsed, maxAmount] = item;
        return {
            date: date.toDate(),
            spent: amountUsed,
            budget: maxAmount,
        };
    });

    return (
        <Box sx={{ position: 'relative', height: '500px', marginTop: 2 }}>
            <ChartContainer
                dataset={dataset}
                series={[
                    {
                        type: 'bar',
                        dataKey: 'spent',
                        color: theme.palette.primary.main,
                        valueFormatter: (v): string => {
                            return v?.toCurrency(currencyStore.currentCurrency, {}) || '';
                        },
                    },
                    {
                        type: 'line',
                        dataKey: 'budget',
                        color: theme.palette.error.main,
                        valueFormatter: (v): string => {
                            return v?.toCurrency(currencyStore.currentCurrency, {}) || '';
                        },
                    },
                ]}
                xAxis={[
                    {
                        dataKey: 'date',
                        scaleType: 'band',
                        valueFormatter: (date: Date ) => {
                            return moment(date).format('MMMM YYYY');
                        },
                    },
                ]}
            >
                <ChartsAxisHighlight x="band" />
                <BarPlot
                    borderRadius={3}
                />
                <LinePlot />

                <ChartsXAxis />
                <ChartsYAxis
                    label={`Spent in ${currencyStore.currentCurrency}`}
                />
                <ChartsTooltip />
            </ChartContainer>
        </Box>
    );
};
